import { useEffect, useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';

import './carousel.css';

const Carousel = ({ imageUrls, onImageClick }) => {
  const [mounted, setMounted] = useState(false);
  const swiperRef = useRef(null);

  useEffect(() => {
        setMounted(true);
  }, []);

  useEffect(() => {
    // Update swiper when imageUrls change
    if (swiperRef.current && swiperRef.current.update) {
        swiperRef.current.update();
    }
  }, [imageUrls]);

  if (!mounted) return null;

  return (
    <div className='my-swiper'>
      <Swiper
            slidesPerView={1}
            navigation={true}
            loop={imageUrls.length > 1}
            modules={[Navigation]}
            className='mySwiper'
            onSwiper={(swiper) => {
                swiperRef.current = swiper;
                setTimeout(() => swiper.update(), 100); // force update after layout
            }}
      >
        {imageUrls.map((url, idx) => (
            <SwiperSlide key={idx}>
                <div className="swiper-zoom-container">
                <img
                    src={url}
                    alt={`Product ${idx}`}
                    className='product-image'
                    onClick={() => onImageClick?.(idx)}
                />
                </div>
            </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Carousel;
